(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  if (typeof customElements.get('product-recommendations') === 'undefined') {
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();
      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const innerHTML = new DOMParser()
                .parseFromString(text, 'text/html')
                .querySelector('product-recommendations');
            if (innerHTML && innerHTML.querySelectorAll('.product-item').length > 0) {
              this.innerHTML = innerHTML.innerHTML;
              setTimeout(function() {
                if ($(document).find('[data-list-shipping-id]').length && $(document).find('.shipping-available-location-name').length) {
                  var deliverySuccess = $(document).find('body').data('delivery-success');
                  var deliveryError = $(document).find('body').data('delivery-error');
                  var shippingFromLocation = $(document).find('.shipping-available-location-name').data('location-name').toString();
                  var variantItemsArray = [];
                  $(document).find('[data-list-shipping-id]').each(function(index) {
                    var variantId = $(this).data('list-shipping-id');
                    var productId = $(this).data('product-id');
                    variantItemsArray[index] = [];
                    variantItemsArray[index]['product-id'] = productId;
                    variantItemsArray[index]['variant-id'] = variantId;
                  });
                  if (variantItemsArray.length > 0) {
                    Shopify.queue = [];
                    for (var i = 0; i < variantItemsArray.length; i++) {
                      var product = variantItemsArray[i]['product-id'];
                      var variant = variantItemsArray[i]['variant-id'];
                      Shopify.queue.push({
                        productId: product,
                        variantId: variant,
                      });
                    }
                  }
                  Shopify.moveAlong = function() {
                    if (Shopify.queue.length) {
                      var request = Shopify.queue.shift();
                      var dataproductId = request.productId;
                      var dataVariantId = request.variantId.toString();
                      if (dataVariantId.indexOf(",") != -1) {
                        Shopify.queueInner = [];
                        var newArray = dataVariantId.split(',');
                        for (var i = 0; i < newArray.length; i++) {
                          Shopify.queueInner.push({
                            variantId: newArray[i],
                          });
                        }
                        var counterCheckQty = 'false';
                        Shopify.moveInnerAlong = function() {
                          if (Shopify.queueInner.length) {
                            var request = Shopify.queueInner.shift();
                            var dataVariant = request.variantId;
                            const variantSectionUrl = '/variants/' + dataVariant + '/?section_id=helper-pickup-availability-extended';
                            fetch(variantSectionUrl)
                              .then(response => response.text())
                              .then(text => {
                                var checkFinalArray = [];
                                var checkFinalArrayInner = {};
                                const sectionInnerHTML = new DOMParser()
                                  .parseFromString(text, 'text/html')
                                  .querySelector('.shopify-section');
                                var variantId = $(sectionInnerHTML).find('#variant-availability').data('variant-id');
                                var variantLocationAvailability = $(sectionInnerHTML).find('#variant-availability').data('location').toString();
                                checkFinalArrayInner['variant-id'] = variantId;
                                var checkQty = 'false';
                                if (shippingFromLocation.indexOf(",") != -1) {
                                  var splitLocation = shippingFromLocation.split(',');
                                  splitLocation.forEach(function(locationName) {
                                    if (variantLocationAvailability.indexOf(locationName) != -1) {
                                      checkQty = 'true';
                                      counterCheckQty = 'true';
                                    }
                                  });
                                } else {
                                  if (variantLocationAvailability.indexOf(shippingFromLocation) != -1) {
                                    checkQty = 'true';
                                    counterCheckQty = 'true';
                                  }
                                }
                                checkFinalArrayInner['available'] = checkQty;
                                checkFinalArray.push(checkFinalArrayInner);
                                if ($(document).find('#itg-item-shipping-availability').length) {
                                  var getItemScript = $(document).find('#itg-item-shipping-availability').html();
                                  var getFinalArray = JSON.parse(getItemScript);
                                  var finalArrayLength = getFinalArray.length;
                                  finalArrayLength = finalArrayLength - 1;
                                  checkFinalArray.forEach(function(variantData) {
                                    finalArrayLength = finalArrayLength + 1;
                                    getFinalArray[finalArrayLength] = {};
                                    getFinalArray[finalArrayLength]['variant-id'] = variantData['variant-id'];
                                    getFinalArray[finalArrayLength]['available'] = variantData['available'];
                                  });
                                  var convertFinalArrayStringify = JSON.stringify(getFinalArray);
                                  $(document).find('#itg-item-shipping-availability').empty().append(convertFinalArrayStringify);
                                } else {
                                  var convertFinalArrayStringify = JSON.stringify(checkFinalArray);
                                  $(document).find('body').append('<script id="itg-item-shipping-availability">' + convertFinalArrayStringify + '</script>');
                                }
                                Shopify.moveInnerAlong();
                              });
                          } else {
                            if (counterCheckQty == 'true') {
                              $(document).find('span[data-product-id="' + dataproductId + '"]').removeClass('alert--circle-loading alert--note alert--error unavailable-delivery').addClass('alert--success').text(deliverySuccess);
                            } else {
                              $(document).find('span[data-product-id="' + dataproductId + '"]').removeClass('alert--circle-loading alert--note alert--success').addClass('alert--error unavailable-delivery').text(deliveryError);
                            }
                            counterCheckQty = 'false';
                            Shopify.moveAlong();
                          }
                        };
                        Shopify.moveInnerAlong();
                      } else {
                        const variantSectionUrl = '/variants/' + dataVariantId + '/?section_id=helper-pickup-availability-extended';
                        fetch(variantSectionUrl)
                          .then(response => response.text())
                          .then(text => {
                            var checkFinalArray = [];
                            var checkFinalArrayInner = {};
                            const sectionInnerHTML = new DOMParser()
                              .parseFromString(text, 'text/html')
                              .querySelector('.shopify-section');
                            var variantId = $(sectionInnerHTML).find('#variant-availability').data('variant-id');
                            var variantLocationAvailability = $(sectionInnerHTML).find('#variant-availability').data('location').toString();
                            checkFinalArrayInner['variant-id'] = variantId;
                            var checkQty = 'false';
                            if (shippingFromLocation.indexOf(",") != -1) {
                              var splitLocation = shippingFromLocation.split(',');
                              splitLocation.forEach(function(locationName) {
                                if (variantLocationAvailability.indexOf(locationName) != -1) {
                                  checkQty = 'true';
                                }
                              });
                            } else {
                              if (variantLocationAvailability.indexOf(shippingFromLocation) != -1) {
                                checkQty = 'true';
                              }
                            }
                            checkFinalArrayInner['available'] = checkQty;
                            checkFinalArray.push(checkFinalArrayInner);
                            if ($(document).find('#itg-item-shipping-availability').length) {
                              var getItemScript = $(document).find('#itg-item-shipping-availability').html();
                              var getFinalArray = JSON.parse(getItemScript);
                              var finalArrayLength = getFinalArray.length;
                              finalArrayLength = finalArrayLength - 1;
                              checkFinalArray.forEach(function(variantData) {
                                finalArrayLength = finalArrayLength + 1;
                                getFinalArray[finalArrayLength] = {};
                                getFinalArray[finalArrayLength]['variant-id'] = variantData['variant-id'];
                                getFinalArray[finalArrayLength]['available'] = variantData['available'];
                              });
                              var convertFinalArrayStringify = JSON.stringify(getFinalArray);
                              $(document).find('#itg-item-shipping-availability').empty().append(convertFinalArrayStringify);
                            } else {
                              var convertFinalArrayStringify = JSON.stringify(checkFinalArray);
                              $(document).find('body').append('<script id="itg-item-shipping-availability">' + convertFinalArrayStringify + '</script>');
                            }
                            if (checkQty == 'true') {
                              $(document).find('span[data-product-id="' + dataproductId + '"]').removeClass('alert--circle-loading alert--note alert--error unavailable-delivery').addClass('alert--success').text(deliverySuccess);
                            } else {
                              $(document).find('span[data-product-id="' + dataproductId + '"]').removeClass('alert--circle-loading alert--note alert--success').addClass('alert--error unavailable-delivery').text(deliveryError);
                            }
                            Shopify.moveAlong();
                          });
                      }
                    }
                  };
                  Shopify.moveAlong();
                }
              }, 1000);
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), { rootMargin: '0px 0px 200px 0px' }).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);
  }

  } catch(e) { console.error(e); }
})();
})();
